import { ContentBlock } from 'components/contentBlock'
import React, { useContext } from 'react'
import s from './winners.module.scss'
import { LocaleContext } from 'contexts/locale'
import IntlMessageFormat from 'intl-messageformat'
import clsx from 'clsx'

/**
 * Display the list of winners
 */
export function Winners() {
  const locale = useContext(LocaleContext)
  const messages = require(`./locales/${locale}.yml`)

  return (
    <>
      <ContentBlock
        header={
          <>
            1. Platz
            <div className='sub header'>
              Gewinnt einen Besuch im Bundeshaus mit den Politreportern der
              Tamedia
            </div>
          </>
        }
        className='center aligned'
      >
        <div className={s.winnerCards}>
          <WinnerCard {...messages.winners.first} locale={locale} />
        </div>
      </ContentBlock>

      <ContentBlock
        header={
          <>
            2.–4. Plätze
            <div className='sub header'>
              Gewinnen je ein Jahres-Digitalabo eines Tamedia-Titels ihrer Wahl
            </div>
          </>
        }
        className='center aligned'
      >
        <div className={clsx(s.winnerCards, s.runnerUps)}>
          {messages.winners.runnerUp.map(entry => (
            <WinnerCard {...entry} locale={locale} key={entry.name} />
          ))}
        </div>
      </ContentBlock>
    </>
  )
}

/**
 * A single card displaying one winner.
 */
function WinnerCard({
  name,
  points,
  difference,
  locale
}: {
  name: string
  points: number
  difference: number
  locale: 'de' | 'fr'
}) {
  const messages = require(`./locales/${locale}.yml`)
  const pointsMessages = new IntlMessageFormat(messages.points, locale + '-CH')
  const differenceMessage = new IntlMessageFormat(
    messages.difference,
    locale + '-CH'
  )

  return (
    <div className={s.winnerCard}>
      <img
        alt='Trophäe'
        src={require('../prizes/trophy.svg')}
        className={s.trophy}
      />
      <div className={s.name}>{name}</div>
      <div
        className={s.points}
        dangerouslySetInnerHTML={{ __html: pointsMessages.format({ points }) }}
      />
      <div
        className={s.difference}
        dangerouslySetInnerHTML={{
          __html: differenceMessage.format({ difference })
        }}
      />
    </div>
  )
}
